import { Box, FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./businessImapctDataTile.css";
import { Legend, Pie, PieChart } from "recharts";
import { ChannelkartNetworkGet } from "../../services/networkService";

import {
  block1,
  block2,
  crossSellOptions,
  focusSellOptions,
  labelToValueMapping,
  PieChart1,
  PieChart2,
  PieChart3,
  recommendationComplians,
  upSellOptions,
} from "./businessImpactConfig";
import { Loader } from "../loader/Loader";
import {
  impactDataType,
  kpiData,
  PieChartMetadataType,
  pieConfigType,
} from "./businessImpactType";
import { popupType } from "../../types/types";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const data01 = [
  { name: "Cross Sell", value: 30, fill: "#00c6b2" },
  { name: "Upsell", value: 22, fill: "#2d5f98" },
  { name: "Regular", value: 20, fill: "#2c8bba" },
];

const data03 = [
  { name: "First time ", value: 60, fill: "#1c7ea0" },
  { name: "Repeat Sales", value: 40, fill: "#00c6b2" },
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  name,
}: PieChartMetadataType) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const labelRadius = outerRadius - 50; // Adjust the label radius as needed


  return (
    <>
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
   
    </>
  );
};

export function BusinessImpactDataTile() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Business Impact"
  const [activePie1, setActivePie1] = useState(false);
  const [activePie2, setActivePie2] = useState(false);
  const [activePie3, setActivePie3] = useState(false);
  const [impactData, setImpactData] = useState<impactDataType>();

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [recommendationtype, setRecommendationType] = useState("Upsell");
  const [tag, setTag] = useState("SKU");

  const ranges = [
    { divider: 1e18, suffix: "E" },
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
  ];

  function formatNumber(data: number) {
    for (let i = 0; i < ranges.length; i++) {
      if (data >= ranges[i].divider) {
        return (
          (data / ranges[i].divider).toFixed(2).toString() + ranges[i].suffix
        );
      }
    }
    return data.toString();
  }

  const generateImpactObjects = (impactArray: kpiData[]) => {
    let newImpactObject = {};
    impactArray.forEach((eachImpactData: kpiData) => {
      const labelName = labelToValueMapping[eachImpactData.kpi_name];
      if (labelName) {
        newImpactObject = {
          ...newImpactObject,
          [labelName]: {
            mtd: formatNumber(parseInt(eachImpactData.mtd, 10)),
            ytd: formatNumber(parseInt(eachImpactData.ytd, 10)),
          },
        };
      }
    });
    setImpactData(newImpactObject);
  };

  const getPieChartData = (pieChartMetaData: pieConfigType[]) => {
    if (impactData) {
     
      const pieData = pieChartMetaData.map((eachMetaData: pieConfigType) => {
        return {
          name: translate(TranslationEnum.business_impact,eachMetaData.name),
          value: parseInt(impactData[eachMetaData.label]?.mtd, 10),
          fill: eachMetaData.fill,
        };
      });
      return pieData;
    }
    return [];
  };

  const getSpecifcPieData = (pieChartMetaData: pieConfigType[],selectedVale:string)=>{
   const AllChart = getPieChartData(pieChartMetaData);
   const systum =  AllChart.filter((eachChart)=>{
    return eachChart.name === selectedVale;
   })
   systum.push({
    "fill":"#AEAEAE",
    "name":"",
    "value":100-systum[0].value
   })
   return systum
  }

  useEffect(() => {
    getImpactData();
  }, []);

  const getImpactData = async () => {
    try {
      const response = await ChannelkartNetworkGet(
        "/v3/analyticsreport/custom?queryName=ImpactReportQuery"
      );
      if (response.status === 200) {
        generateImpactObjects(response.data.features);
      } else {
        throw new Error();
      }
    } catch (error) {
      openPopUp("Something went wrong", "Error");
    }
  };

  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };

  return (
    <>
      {impactData ? (
        <div className="parent-div">
          <div className="parent-one-div">
            <div className="fst-data-points-segment-parent">
              <div className="container-box-segment1">
                <Box className="data-tile">
                  <div className="data-points-parent">
                    {block1.map((eachOptions, index) => {
                      return (
                        <div
                          className={`total-sales-data ${
                            index === 0 ? "no-border" : ""
                          }`}
                        >
                          <p className="total-sales-data-label">
                            {impactData[eachOptions]
                              ? impactData[eachOptions].mtd
                              : "-"}
                          </p>
                          <p>{eachOptions}</p>
                        </div>
                      );
                    })}
                  </div>
                </Box>
                <Box className="data-tile-crossell">
                  <div className="data-points-parent">
                    {block2.map((eachOptions, index) => {
                      return (
                        <div
                          className={`total-sales-data ${
                            index === 0 ? "no-border" : ""
                          }`}
                        >
                          <p className="total-sales-data-label">
                            {impactData[eachOptions]
                              ? impactData[eachOptions].mtd
                              : "-"}
                          </p>
                          <p>{eachOptions}</p>
                        </div>
                      );
                    })}
                  </div>
                </Box>
              </div>

              <div className="container-box-segment2">
                <Box className="corsssell-parent-div">
                  <div className="cross-sell-heading"> {translate(TranslationEnum.business_impact,"Cross Sell")}</div>
                  <div className="cross-sell-data">
                    {crossSellOptions.map((eachOptions, index) => {
                      return (
                        <div
                          className={`crosssell-vs-total ${
                            index === 0 ? "no-border" : ""
                          }`}
                        >
                          <p className="paragraph-Heading">
                            {impactData[eachOptions]
                              ? impactData[eachOptions].mtd
                              : "-"}
                          </p>
                          <p>{translate(TranslationEnum.business_impact,eachOptions)}</p>
                        </div>
                      );
                    })}
                  </div>
                </Box>
                <Box className="recommendation-compliance">
                  <div className="cross-sell-heading">
                  {translate(TranslationEnum.business_impact,"Recommendation Compliance")}
                  </div>
                  <div className="recommendation-sell-data">
                    {recommendationComplians.map((eachComplians, index) => {
                      return (
                        <div
                          className={`crosssell-vs-total ${
                            index === 0 ? "no-border" : ""
                          }`}
                        >
                          <p className="paragraph-Heading">
                            {impactData[eachComplians]
                              ? impactData[eachComplians].mtd
                              : "-"}
                          </p>
                          <p>{translate(TranslationEnum.business_impact,eachComplians)}</p>
                        </div>
                      );
                    })}
                  </div>
                </Box>
              </div>
            </div>
            <div className="fst-pie-chart-div">
              <Box className="pie-chart-div">
                <div className="chart-parent-inner-div">
                  <div className="chart-div">
                  
                    <PieChart width={300} height={250}>
                    <Legend layout="horizontal" verticalAlign="top" align="center" />
                      <Pie
                        data={getPieChartData(PieChart1)}
                        dataKey="value"
                        nameKey="name"
                        cx="47%"
                        cy="50%"
                        outerRadius={100}
                        label={activePie1 && renderCustomizedLabel}
                        stroke="none"
                        labelLine={false}
                        onMouseEnter={() => {
                          setActivePie1(true);
                        }}
                        onMouseLeave={() => {
                          setActivePie1(false);
                        }}
                      />
                    </PieChart>
                  </div>
                  <div className="chart-description">
                  {translate(TranslationEnum.business_impact,"Comparative analysis of all sales")}
                  </div>
                </div>
              </Box>
            </div>
          </div>
          <div className="parent-two-div">
            <div className="upsell-focussell-pie">
              <div className="data-points-parent-segment-two">
                <Box className="up-sell-parent">
                  <div className="cross-sell-heading">{translate(TranslationEnum.business_impact,"Up Sell")}</div>
                  <div className="up-sell-data">
                    {upSellOptions.map((eachOptions, index) => {
                      return (
                        <div
                          className={`crosssell-vs-total ${
                            index === 0 ? "no-border" : ""
                          }`}
                        >
                          <p className="paragraph-Heading">
                            {impactData[eachOptions]
                              ? impactData[eachOptions].mtd
                              : "-"}
                          </p>
                          <p>{translate(TranslationEnum.business_impact,eachOptions)}</p>
                        </div>
                      );
                    })}
                  </div>
                </Box>
                {/* <Box className="up-sell-parent">
                  <div className="cross-sell-heading">Focus Sell</div>
                  <div className="up-sell-data">
                    {focusSellOptions.map((eachOptions, index) => {
                      return (
                        <div
                          className={`crosssell-vs-total ${
                            index === 0 ? "no-border" : ""
                          }`}
                        >
                          <p className="paragraph-Heading">
                            {impactData[eachOptions]
                              ? impactData[eachOptions].mtd
                              : "-"}
                          </p>
                          <p>{eachOptions}</p>
                        </div>
                      );
                    })}
                  </div>
                </Box> */}
              </div>

              <Box className="cross-sell-impace">
                <div className="cross-sell-impace-inner-div">
                  <div className="cross-sell-impace-chart">
                    
                    <PieChart width={250} height={170} >
                    <Legend layout="horizontal" verticalAlign="top" align="center" />
                      <Pie
                        data={getPieChartData(PieChart2)}
                        startAngle={180}
                        endAngle={0}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="90%"
                        innerRadius={50}
                        outerRadius={100}
                        stroke="none"
                        label={activePie2 && renderCustomizedLabel}
                        labelLine={false}
                        onMouseEnter={() => {
                          setActivePie2(true);
                        }}
                        onMouseLeave={() => {
                          setActivePie2(false);
                        }}
                      />
                    </PieChart>
                  </div>
                  <div className="cross-sell-impact-chart-description">
                  {translate(TranslationEnum.business_impact,"Cross sell first time vs repeat sales")}
                  </div>
                </div>
              </Box>
            </div>
            <Box className="outlet-impact">
              <div className="outlet-impact-inner-div">
                <div className="drpodown-parent">
                  <FormControl sx={{ m: 1, minWidth: 70 }} size="small">
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={recommendationtype}
                      onChange={(e) => {
                        setRecommendationType(e.target.value);
                      }}
                    >
                      <MenuItem value={"Upsell"}>{translate(TranslationEnum.business_impact,"UpSell")}</MenuItem>
                      <MenuItem value={"CrossSell"}>{translate(TranslationEnum.business_impact,"CrossSell")}</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl sx={{ m: 1, minWidth: 70 }} size="small">
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={tag}
                      onChange={(e) => {
                        setTag(e.target.value);
                      }}
                    >
                      <MenuItem value={"SKU"}>{translate(TranslationEnum.business_impact,"SKU")}</MenuItem>
                      <MenuItem value={"Outlet"}>{translate(TranslationEnum.business_impact,"Outlet")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="chart-div">
                  <PieChart width={230} height={115}>
                    <Pie
                      startAngle={180}
                      endAngle={0}
                      data={getSpecifcPieData(PieChart3,`${recommendationtype}-${tag}`)}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="90%"
                      outerRadius={100}
                      innerRadius={50}
                      label={activePie3 && renderCustomizedLabel}
                      stroke="none"
                      labelLine={false}
                      onMouseEnter={() => {
                        setActivePie3(true);
                      }}
                      onMouseLeave={() => {
                        setActivePie3(false);
                      }}
                    />
                  </PieChart>
                </div>
                <p className="outlet-impact-chart-description">
                  {`${translate(TranslationEnum.business_impact,recommendationtype)} ${translate(TranslationEnum.business_impact,tag)} ${translate(TranslationEnum.business_impact,"Impacted")}`}
                </p>
              </div>
            </Box>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
}
